import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { IMG } from "@/lib/data";
import { SITE } from "@/lib/site";

export default function About() {
  return (
    <div data-testid="page-about" className="pt-32 pb-24">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <div className="grid gap-12 lg:grid-cols-12 items-center">
          <div className="lg:col-span-6">
            <div className="overline">About Malek</div>
            <h1 className="font-display text-5xl sm:text-6xl mt-4 tracking-tight text-balance leading-tight">
              More than eight years of helping women
              <span className="italic font-light"> feel like themselves again.</span>
            </h1>
            <div className="mt-8 space-y-5 text-[hsl(var(--onyx)/0.7)] leading-relaxed">
              <p>
                I'm Malek — salon owner, hair extension specialist, hair loss
                practitioner, educator and founder of NøoksPro.
              </p>
              <p>
                For over 8 years I've been helping women leave my chair feeling
                more confident than when they walked in. Whether it's creating
                seamless hair extensions, designing bespoke hair loss solutions
                or giving someone a complete transformation, my goal has always
                been the same — helping people feel like the best version of
                themselves.
              </p>
              <p>
                As my career has grown, so has my passion for education. I now
                train the next generation of stylists through NøoksPro Training
                Academy, sharing the techniques, knowledge and confidence I've
                built over the years so others can create successful careers
                doing what they love.
              </p>
              <p>
                One thing that always frustrated me was the inconsistency in
                the quality of hair available. I was tired of trying different
                brands and never knowing if the hair would meet the standards
                my clients deserved. So instead of settling, I decided to
                create my own. NøoksPro Hair was built around the quality,
                longevity and reliability I always wanted to offer — premium
                hair that I trust enough to use on my own clients every single
                day.
              </p>
              <p>
                Every appointment, every student and every client matters to
                me. I believe great hair isn't just about how it looks — it's
                about how it makes you feel.
              </p>
              <p>
                When you sit in my chair, you're not just getting a service.
                You're getting honest advice, years of experience and someone
                who's genuinely invested in helping you achieve your hair
                goals.
              </p>
            </div>
            <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
              {[
                { k: "8+", v: "Years" },
                { k: "500+", v: "Clients" },
                { k: "5★", v: "Rated" },
              ].map((s) => (
                <div key={s.k}>
                  <div className="font-display text-3xl">{s.k}</div>
                  <div className="text-xs uppercase tracking-widest text-[hsl(var(--onyx)/0.5)] mt-1">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
            <a
              href={SITE.bookingUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="about-book-cta"
              className="btn-pill btn-primary mt-10"
            >
              Book with Malek <ArrowUpRight size={16} />
            </a>
          </div>
          <div className="lg:col-span-6">
            <div className="rounded-[2rem] overflow-hidden hover-zoom aspect-[4/5] max-w-md mx-auto lg:mx-0 lg:ml-auto">
              <img
                src="https://luxury-hair-academy-2.preview.emergentagent.com/api/files/malek-dridi/about/caa9d2ce1f5f4d04beedaef8c34de1ae.jpg"
                alt="Malek Dridi — Salon owner, hair extension specialist and educator"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        <Reveal className="mt-24 rounded-[2rem] p-10 sm:p-14 bg-blush-soft">
          <div className="grid gap-8 lg:grid-cols-2 items-center">
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-balance">
              “I don't want you leaving the salon looking good. I want you
              leaving <span className="italic font-light">feeling different.</span>”
            </h2>
            <p className="text-[hsl(var(--onyx)/0.7)] leading-relaxed">
              Every service, every course, every consultation — built around
              that single idea. Beautiful hair is the outcome. Confidence is
              the point.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
